import { render, staticRenderFns } from "./FormHotelRooms.vue?vue&type=template&id=d3e145ca&"
import script from "./FormHotelRooms.vue?vue&type=script&lang=js&"
export * from "./FormHotelRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3e145ca')) {
      api.createRecord('d3e145ca', component.options)
    } else {
      api.reload('d3e145ca', component.options)
    }
    module.hot.accept("./FormHotelRooms.vue?vue&type=template&id=d3e145ca&", function () {
      api.rerender('d3e145ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/form/rooms/FormHotelRooms.vue"
export default component.exports